import styled from 'styled-components'
import Img from 'gatsby-image'
import { globalVariables, ClickableIcon } from '~/styles/global'

const localVariables = {
  infoMargin: '0.5em',
}

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 0.75rem;
`

export const Info = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  justify-content: flex-start;
  padding: 0 0.5em;
`

export const InfoRight = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`

export const ItemImage = styled.img`
  height: 6.25rem;
`

export const Title = styled.h2`
  font-weight: 600;
  text-transform: uppercase;
  margin-top: 0;
  margin-bottom: ${localVariables.infoMargin};
`

export const Price = styled.h2`
  margin-top: 0;
  font-weight: 400;
  margin-bottom: ${localVariables.infoMargin};
`

export const SelectedOptions = styled.div`
  margin-bottom: ${localVariables.infoMargin};
`

export const SelectedOption = styled.span`
  text-transform: uppercase;
`

export const QuantityContainer = styled.div`
  border: none;
  display: flex;
  width: 5rem;
`

export const QuantityButton = styled.button`
  flex-grow: 1;
  background: ${globalVariables.colors.black};
  color: white;
  border: unset;
  cursor: pointer;
  padding: 0;
`

export const Quantity = styled.span`
  flex-grow: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
`

export const DeleteButton = styled(ClickableIcon)`
  padding: 0;

  & svg {
    width: 1.25em;
    height: 1.25em;
  }
`
